import React from "react";
import {Redirect, useLocation} from "react-router-dom";
import PropTypes from "prop-types";
import useAuth from "src/hooks/useAuth";
import {URL_TEMPLATES as URL} from "src/urlTemplates";

const AuthGuard = ({children}) => {
    const {isAuthenticated, user} = useAuth();
    const location = useLocation();

    if (!isAuthenticated) {
        return <Redirect to={URL.LOGIN}/>;
    }

    if (user.passwordExpired && location.pathname !== URL.ACCOUNT) {
        return <Redirect to={URL.ACCOUNT}/>;
    }

    return <>{children}</>;
};

AuthGuard.propTypes = {
    children: PropTypes.node
};

export default AuthGuard;
